import React from 'react'
import { useForm } from '@inertiajs/react'
import classNames from 'classnames/bind'
import type { UserProfile } from '../../types'
import styles from '../../UserProfile.module.scss'

const cx = classNames.bind(styles)

interface SettingsTabProps {
  user: UserProfile
}

export default function SettingsTab({ user }: SettingsTabProps) {
  const { data, setData, put, processing, errors, recentlySuccessful } = useForm({
    name: user.name,
    status: user.status,
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    put(`/admin/users/${user.id}`)
  }

  return (
    <form className={cx('form')} onSubmit={handleSubmit}>
      <div className={cx('formGroup')}>
        <label className={cx('formLabel')} htmlFor="profile-name">Name</label>
        <input
          id="profile-name"
          type="text"
          className={cx('formControl')}
          value={data.name}
          onChange={e => setData('name', e.target.value)}
          disabled={processing}
        />
        {errors.name && <span style={{ fontSize: 12, color: 'var(--danger)' }}>{errors.name}</span>}
      </div>

      <div className={cx('formGroup')}>
        <label className={cx('formLabel')} htmlFor="profile-status">Status</label>
        <select
          id="profile-status"
          className={cx('formControl')}
          value={data.status}
          onChange={e => setData('status', e.target.value as 'active' | 'disabled')}
          disabled={processing}
        >
          <option value="active">Active</option>
          <option value="disabled">Disabled</option>
        </select>
        {errors.status && <span style={{ fontSize: 12, color: 'var(--danger)' }}>{errors.status}</span>}
      </div>

      <div className={cx('formActions')}>
        <button type="submit" className={cx('btn', 'btnPrimary')} disabled={processing}>
          {processing ? 'Saving…' : 'Save'}
        </button>
        {recentlySuccessful && (
          <span style={{ fontSize: 12, color: 'var(--success)', alignSelf: 'center' }}>Saved.</span>
        )}
      </div>
    </form>
  )
}
